import SubPage from "../components/SubPage";

export default function Knowledge() {
  return (
    <SubPage tKey="ds.page_knowledge" image="/img/aerial-panels.jpg"
      sections={[
        { title: "ds.page_knowledge.s1_title", body: "ds.page_knowledge.s1_body" },
        { title: "ds.page_knowledge.s2_title", body: "ds.page_knowledge.s2_body" },
        { title: "ds.page_knowledge.s3_title", body: "ds.page_knowledge.s3_body" },
        { title: "ds.page_knowledge.s4_title", body: "ds.page_knowledge.s4_body" },
      ]} />
  );
}
